import { localAgentCatalogSchema, localAgentCatalogSelectableReasonSchema } from "../runtime/local-agent-catalog.js";
import { daemonServiceLaneSchema } from "../daemon/service-contract.js";
import { START_BOUNDED_ID_SCHEMA, START_BOUNDED_VERSION_SCHEMA, START_ISO_DATE_TIME_SCHEMA, startReplyReadinessSummarySchema } from "./shared.js";
import * as z$1 from "zod/v4";
//#region src/schemas/start/device-projection.ts
const startBackgroundHelperInstallStatusSchema = z$1.enum([
	"not_installed",
	"installed_current",
	"installed_outdated",
	"unknown"
]);
const startBackgroundHelperRuntimeStatusSchema = z$1.enum([
	"running",
	"stale",
	"not_running",
	"unknown"
]);
const startBackgroundHelperExecutionCompatibilityStatusSchema = z$1.enum(["compatible", "update_required"]);
const startBackgroundHelperExecutionCompatibilityReasonCodeSchema = z$1.enum([
	"daemon.runtime_contract.compatible",
	"daemon.runtime_contract.missing",
	"daemon.runtime_contract.mismatch",
	"daemon.runtime_contract.unavailable",
	"daemon.runtime_contract.not_observed"
]);
const startBackgroundHelperExecutionCompatibilitySchema = z$1.strictObject({
	status: startBackgroundHelperExecutionCompatibilityStatusSchema,
	reasonCode: startBackgroundHelperExecutionCompatibilityReasonCodeSchema,
	expectedEpoch: START_BOUNDED_ID_SCHEMA,
	observedEpoch: z$1.union([START_BOUNDED_ID_SCHEMA, z$1.null()]),
	updatedAt: z$1.union([START_ISO_DATE_TIME_SCHEMA, z$1.null()])
});
const startSkillsReadinessStatusSchema = z$1.enum([
	"up_to_date",
	"action_required",
	"no_targets",
	"unknown"
]);
const startDeviceAgentSelectableReasonSchema = localAgentCatalogSelectableReasonSchema;
const startBackgroundHelperProjectionSchema = z$1.strictObject({
	installStatus: startBackgroundHelperInstallStatusSchema,
	runtimeStatus: startBackgroundHelperRuntimeStatusSchema,
	installedVersion: z$1.union([START_BOUNDED_VERSION_SCHEMA, z$1.null()]),
	expectedVersion: START_BOUNDED_VERSION_SCHEMA,
	executionCompatibility: startBackgroundHelperExecutionCompatibilitySchema.optional()
});
const startSkillsReadinessSummarySchema = z$1.strictObject({
	upToDate: z$1.number().int().min(0),
	outdated: z$1.number().int().min(0),
	missing: z$1.number().int().min(0),
	externalConflict: z$1.number().int().min(0)
});
const startSkillsReadinessProjectionSchema = z$1.strictObject({
	status: startSkillsReadinessStatusSchema,
	targetCount: z$1.number().int().min(0),
	summary: startSkillsReadinessSummarySchema
}).superRefine((value, ctx) => {
	if (value.summary.upToDate + value.summary.outdated + value.summary.missing + value.summary.externalConflict !== value.targetCount) ctx.addIssue({
		code: "custom",
		message: "skills readiness summary counts must add up to targetCount",
		path: ["summary"]
	});
});
const startDeviceAgentCatalogSchema = localAgentCatalogSchema;
const startDeviceProjectionSchema = z$1.strictObject({
	deviceId: START_BOUNDED_ID_SCHEMA,
	runtimeLane: daemonServiceLaneSchema,
	observedAt: START_ISO_DATE_TIME_SCHEMA,
	backgroundHelper: startBackgroundHelperProjectionSchema,
	skillsReadiness: startSkillsReadinessProjectionSchema,
	deviceAgentCatalog: startDeviceAgentCatalogSchema,
	deviceReplyReadiness: startReplyReadinessSummarySchema
});
//#endregion
export { startBackgroundHelperExecutionCompatibilityReasonCodeSchema, startBackgroundHelperExecutionCompatibilitySchema, startBackgroundHelperExecutionCompatibilityStatusSchema, startBackgroundHelperInstallStatusSchema, startBackgroundHelperProjectionSchema, startBackgroundHelperRuntimeStatusSchema, startDeviceAgentCatalogSchema, startDeviceAgentSelectableReasonSchema, startDeviceProjectionSchema, startSkillsReadinessProjectionSchema, startSkillsReadinessStatusSchema, startSkillsReadinessSummarySchema };

//# sourceMappingURL=device-projection.js.map